<main>
    <router-outlet></router-outlet>
</main>

<footer *ngIf="showFooter" class="bg-slate-900 border-t border-slate-700/60">
  <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-4 flex flex-col sm:flex-row items-center justify-between gap-3">
    <span class="text-xs text-slate-400">
      © 2025 <a href="https://biccrm.com/" target="_blank" rel="noopener noreferrer"
                class="text-slate-300 hover:text-white transition-colors duration-150 font-medium">Business Intelligence™</a>.
      Todos los derechos reservados.
    </span>
    <img src="https://comprasinteligentes.co/logobic.png" alt="Business Intelligence" class="h-5 w-auto opacity-70 hover:opacity-100 transition-opacity duration-150">
  </div>
</footer>

<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "#fff" type = "square-jelly-box" [fullScreen] = "true"><p style="color: white" > Cargando... </p></ngx-spinner>
